module.exports = __webpack_public_path__ + "static/img/peopleBg.f17a9a13.jpg";